import axiosClient from '../axiosClient';

export const targetAnalyticsApi = {
  // Brandwise Analysis APIs
  getQuarterlyAnalysis: async (params) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.year) queryParams.append('year', params.year);
      if (params.slpCode) queryParams.append('slpCode', params.slpCode);
      if (params.region) queryParams.append('region', params.region);
      if (params.state) queryParams.append('state', params.state);
      
      const data = await axiosClient.get(`/target-analytics/quarterly-analysis?${queryParams.toString()}`);
      return data;
    } catch (error) {
      console.error('Error fetching quarterly analysis:', error);
      throw error;
    }
  },

  // Percentage Analysis APIs
  
  getPercentageAnalysis: async (type, year) => {
    try {
      const data = await axiosClient.get(`/target-analytics/percentage-analysis?type=${type}&year=${year}`);
      return data;
    } catch (error) {
      console.error('Error fetching percentage analysis:', error);
      throw error;
    }
  },

  // Filter options APIs
  getSalesPersons: async () => {
    try {
      const data = await axiosClient.get('/target-analytics/salesperson-list');
      return data;
    } catch (error) {
      console.error('Error fetching sales persons:', error);
      throw error;
    }
  },

  getCategories: async () => {
    try {
      const data = await axiosClient.get('/target-analytics/category-list');
      return data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  // Invoice details API
  getInvoiceDetails: async (year, filterType, filterValue) => {
    try {
      const data = await axiosClient.get(
        `/target-analytics/invoice-details?year=${encodeURIComponent(year)}&filterType=${filterType}&filterValue=${encodeURIComponent(filterValue)}`
      );
      return data;
    } catch (error) {
      console.error('Error fetching invoice details:', error);
      throw error;
    }
  }
};